export const featureFlags = {
    INCLUDE_RECUPERATION_IN_CALCULATIONS: false
}